import React, { FunctionComponent } from 'react';

import { InsuredItem } from 'scenes/common/types';
import SingleSegmentedControlStep from 'scenes/common/components/Steps/SingleSegmentedControlStep';
import { HomeFullPageProps } from 'scenes/home/components/FullPage/types';
import { getNumberOfVisits } from 'scenes/home/selectors';
import { NUMBER_OF_VISITS_OPTIONS } from 'scenes/home/types';

const STATE_KEY = 'numberOfVisits';
const QUESTION = `On average, how many people visit the ${InsuredItem.Home} for business reasons each week?`;

const NumberOfVisitsStep: FunctionComponent<HomeFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <SingleSegmentedControlStep
    onNext={onNext}
    question={QUESTION}
    stateKey={STATE_KEY}
    options={NUMBER_OF_VISITS_OPTIONS}
    defaultStateValue={getNumberOfVisits(funnelState)}
    validationRules={{
      validate: {
        oneOf: (value: number) =>
          NUMBER_OF_VISITS_OPTIONS.some((option) => option.value === value),
      },
    }}
  />
);

export default NumberOfVisitsStep;
